/* eslint-disable @typescript-eslint/no-unused-vars */
export const audienceCampaignBmcRedirectStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .bmc_redirect_page': {
    padding: '20px 32px',
    width: '100%',
  },
  '& h1.bmc_redirect_header': {
    margin: 0,
    fontSize: 20,
    color: palette.neutralPrimary,
  },

  '& .bmc_save_bar': {
    borderTop: `1px solid ${palette.neutralLight}`,
    paddingTop: 16,

    '& .btn-save': {
      marginRight: 12,
    },
  },
  '& .bmc_url_link': {
    display: 'inline-block',
    margin: '25px 0 25px 5px',
  },
});
